export const MONETAG_ZONE_ID = '10970381';
export const MONETAG_SRC = 'https://n6wxm.com/vignette.min.js';
export const MONETAG_COOLDOWN_MS = 10 * 60 * 1000;
export const MONETAG_LAST_TRIGGER_KEY = 'monetag_last_trigger_ts';

export function triggerMonetagVignette(eventKey = 'default', options = {}) {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    const { bypassCooldown = false, updateCooldown = !bypassCooldown } = options;

    const now = Date.now();
    let lastGlobalTrigger = 0;
    if (!bypassCooldown) {
        try {
            lastGlobalTrigger = Number(localStorage.getItem(MONETAG_LAST_TRIGGER_KEY) || 0);
        } catch (err) {
            lastGlobalTrigger = Number(window.__monetag_last_trigger_global || 0);
        }
        if (now - lastGlobalTrigger < MONETAG_COOLDOWN_MS) return;
    }

    const target = [document.documentElement, document.body].filter(Boolean).pop();
    if (!target) return;

    // Prevent accidental duplicate injection within the same tick/very short burst.
    const dedupeKey = `__monetag_last_trigger_${eventKey}`;
    const last = window[dedupeKey] || 0;
    if (now - last < 1000) return;
    window[dedupeKey] = now;
    if (updateCooldown) {
        window.__monetag_last_trigger_global = now;
        try {
            localStorage.setItem(MONETAG_LAST_TRIGGER_KEY, String(now));
        } catch (err) {}
    }

    const script = document.createElement('script');
    script.dataset.zone = MONETAG_ZONE_ID;
    script.src = MONETAG_SRC;
    target.appendChild(script);
}
